<template>
  <div class="container-fluid px-0">
    <!-- Date Range Section -->
    <div class="row mb-4">
      <!-- Total Giving -->
      <div class="col-lg-3 col-md-6 mb-3 pr-0">
        <div class="card card-summary bg-gray-400 h-100 pb-1 px-3 pt-3">
          <div
            class="card-icon d-flex justify-content-between my-2 align-items-center"
          >
            <span class="card-text">Total Giving</span>
            <span class="card-text">
              <el-dropdown trigger="click">
                <span
                  class="w-100 text-center text-dak mt-1-5 font-weight-bold text-head d-flex align-items-center"
                >
                  <span>
                    {{ selectedPeriod ? selectedPeriod.name : "Select" }}</span
                  >
                  <el-icon class="el-icon--right text-dak">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu
                    v-for="(item, index) in periods"
                    :key="index"
                  >
                    <el-dropdown-item @click="setSelectedPeriod(item)">{{
                      item.name
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </span>
          </div>
          <div class="card-content text-center mt-3">
            <div class="card-title mb-2">
              <span class="mr-2 fw-300 h3">{{
                tenantCurrency ? tenantCurrency.currencySymbol : ""
              }}</span>
              <span class="fw-500"> {{ totalAmount }}</span>
            </div>
            <div class="d-flex justify-content-between">
              <div class="s-12" style="color: #848181">
                Online<br />
                <div class="s-16 text-black">
                  <span class="fw-300">{{
                    tenantCurrency ? tenantCurrency.currencySymbol : ""
                  }}</span>
                  {{ formatNumber(chartData.totalGivingOnline) }}
                </div>
              </div>
              <div class="s-12" style="color: #848181">
                In–Church<br />
                <div class="s-16 text-black">
                  <span class="fw-300" style="font-style: light">{{
                    tenantCurrency ? tenantCurrency.currencySymbol : ""
                  }}</span>
                  {{ formatNumber(chartData.totalGivingInChurch) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Average Gift -->
      <div class="col-lg-3 col-md-6 mb-3 pr-0">
        <div class="card card-summary bg-gray-400 h-100 pb-1 px-3 pt-3">
          <div
            class="card-icon d-flex justify-content-between my-2 align-items-center"
          >
            <span class="card-text">Average Gift</span>
          </div>
          <div class="card-content text-center mt-4">
            <h3 class="card-title fw-500">
              <span class="fw-300">{{
                tenantCurrency ? tenantCurrency.currencySymbol : ""
              }}</span>
              {{ formatNumber(chartData.averageGift) }}
            </h3>
          </div>
        </div>
      </div>

      <!-- Most Project Funded -->
      <div class="col-lg-3 col-md-6 mb-3 pr-0">
        <div class="card card-summary bg-gray-400 h-100 pb-1 px-3 pt-3">
          <div
            class="card-icon d-flex justify-content-between my-2 align-items-center"
          >
            <span class="card-text">Most project funded</span>
          </div>
          <div class="card-content text-center mt-4">
            <h4 class="card-title fw-400">
              {{ chartData.mostProjectFunded }}
            </h4>
          </div>
        </div>
      </div>

      <!-- Average Yearly Inflow -->
      <div class="col-lg-3 col-md-6 mb-3 pr-0">
        <div
          class="card card-summary d-flex flex-column justify-content-between align-items-center bg-gray-400 h-100 pb-1 px-3 pt-3"
        >
          <div
            class="card-icon d-flex justify-content-between my-2 align-items-center"
          >
            <span class="card-text">Average Yearly inflow</span>
          </div>
          <div class="card-content text-center">
            <h3 class="card-title fw-500">
              <span class="fw-300">{{
                tenantCurrency ? tenantCurrency.currencySymbol : ""
              }}</span>
              {{ formatNumber(chartData.averageYearlyInflow) }}
            </h3>
          </div>
          <!-- <router-link to="" class="mr-3 text-decoration-none text-dak px-0">
            <span class="d-flex align-items-center s-14">
              <span class="pr-1"><ChatBarVue class="w-10 h-10" /></span>
              <u>
                {{
                  navigatorLang === "en-US"
                    ? "show all analytics"
                    : $t("people.showAnalytics")
                }}
              </u>
            </span>
          </router-link> -->
        </div>
      </div>
    </div>

    <!-- Charts Section -->
    <div class="row">
      <!-- Giving Trend Chart -->
      <div class="col-md-7 mb-4">
        <div class="card border- shadow-sm h-100">
          <div class="card-body">
            <div
              class="d-flex justify-content-between align-items-center flex-wrap mb-4"
            >
              <div class="d-flex align-items-center">
                <div><PiggyBank class="w-14 h-14" /></div>
                <div style="color: #0b3274" class="mb-0 s-20 fw-500">
                  Giving Trend
                </div>
              </div>
              <div class="d-flex align-items-center gap-3">
                <div class="">
                  <el-button
                    link
                    class=""
                    :class="
                      activeTab === 'online'
                        ? 'primary--text font-weight-600'
                        : 'text-dak fw-400'
                    "
                    @click="activeTab = 'online'"
                  >
                    <span class="s-14">Online</span>
                  </el-button>
                  <el-button
                    link
                    class=""
                    :class="
                      activeTab === 'inchurch'
                        ? 'primary--text font-weight-600'
                        : 'text-dak fw-400'
                    "
                    @click="activeTab = 'inchurch'"
                  >
                    <span class="s-14">Inchurch</span>
                  </el-button>
                </div>
              </div>
            </div>

            <!-- Chart Placeholder -->
            <div
              class="chart-container"
              style="height: 300px; position: relative"
            >
              <TrendAreaChart
                :data="trendAreaChartData"
                :categories="monthLabels"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Donation Distribution -->
      <div class="col-md-5 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <el-button
                link
                class="text-wrap"
                :class="
                  donationTab === 'donationCategory'
                    ? 'primary--text font-weight-600'
                    : 'text-dak fw-400'
                "
                @click="donationTab = 'donationCategory'"
              >
                <span class="s-14"> Donation by Category</span>
              </el-button>
              <el-button
                link
                class="text-wrap"
                :class="
                  donationTab === 'donationChannel'
                    ? 'primary--text font-weight-600'
                    : 'text-dak fw-400'
                "
                @click="donationTab = 'donationChannel'"
              >
                <span class="s-14">Donation by Channel </span>
              </el-button>
            </div>

            <!-- Donut Chart Placeholder -->
            <!-- Payment Method Distribution Chart -->
            <div class="row" v-if="donationTab === 'donationChannel'">
              <div class="col-md-12">
                <div
                  class="donut_chart_container"
                  style="height: 300px; position: relative"
                >
                  <DonutChart
                    dom-id="donutChartByChannel"
                    :seriesData="chartDataSeriesByChannel"
                    :colour="chartColors"
                    :height="300"
                    chart-type="donut"
                    inner-size="75%"
                    center-text="Donation Channel"
                    :show-legend="true"
                    legend-position="bottom"
                    :center-value="totalDonationChannel"
                    :show-data-labels="false"
                    @chart-click="handleChartClick"
                    @legend-click="handleLegendClick"
                    @chart-ready="onChartReady"
                  />
                </div>
              </div>
            </div>
            <div class="row" v-if="donationTab === 'donationCategory'">
              <div class="col-md-12 ">
                <div
                  class="donut_chart_container"
                  style="height: 300px; position: relative"
                >
                  <DonutChart
                    dom-id="donutChartByCategory"
                    :seriesData="chartDataSeriesByCategory"
                    :colour="chartColors"
                    :height="300"
                    chart-type="donut"
                    inner-size="75%"
                    center-text="Donation Category"
                    :show-legend="true"
                    legend-position="bottom"
                    :center-value="totalDonationCategory"
                    :show-data-labels="false"
                    @chart-click="handleChartClick"
                    @legend-click="handleLegendClick"
                    @chart-ready="onChartReady"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, inject } from "vue";
import ChatBarVue from "../../../components/svg/ChatBar.vue";
import PiggyBank from "../../../components/icons/PiggyBankIcon.vue";
import DonutChart from "@/components/charts/DonationDonutChart.vue";
// import contributionservice from "../../../services/financials/contributionservice";
import TrendAreaChart from "../../../components/charts/TrendAreaChart.vue";
import { computed } from "vue";

const props = defineProps({
  tenantCurrency: { type: Object, required: true },
  totalAmount: { type: [String, Number], required: true },
  chartData: { type: Object, required: true }, // single object for everything
});
const emit = defineEmits(["selected-period"]); // declare emits

const givingData = ref([200, 300, 400, 500, 450, 600, 550, 700, 800]);
const monthLabels = ref([
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]);

const activeTab = ref("inchurch");
const donationTab = ref("donationCategory");
const sortBy = ref("month");
const primarycolor = inject("primarycolor");
const navigatorLang = ref(navigator.language);

const periods = ref([
  { name: "One Week", key: "oneWeek" },
  { name: "This Week", key: "thisWeek" },
  { name: "Last Week", key: "lastWeek" },
  { name: "This Month", key: "thisMonth" },
  { name: "Last Month", key: "lastMonth" },
  { name: "Last 30days", key: "lastThirtyDays" },
  { name: "Last 90days", key: "lastNinetyDays" },
  { name: "One Year", key: "oneYear" },
]);
const selectedPeriod = ref(periods.value[7]);

const paymentMethodData = ref([]);

const chartColors = ref([
  "#14B8A6", // teal
  "#3B82F6", // vivid blue
  "#6366F1", // cyan
  "#E697FF", // mint
  "#63ABFD", // sky blue
  "#CACACA", // emerald
]);

const totalDonationChannel = computed(() => {
  return props.chartData && props.chartData.donationDistributionByChannel
    ? Math.round(
        props.chartData.donationDistributionByChannel.reduce(
          (sum, item) => sum + item.amount,
          0
        )
      ).toLocaleString()
    : 0;
});
const totalDonationCategory = computed(() => {
  return props.chartData &&
    props.chartData.donationDistributionByOfferingCategory
    ? Math.round(
        props.chartData.donationDistributionByOfferingCategory.reduce(
          (sum, item) => sum + item.amount,
          0
        )
      ).toLocaleString()
    : 0;
});
const chartDataSeriesByChannel = computed(() => {
  return props.chartData && props.chartData.donationDistributionByChannel
    ? props.chartData.donationDistributionByChannel.map((item) => ({
        name: item.channel,
        y: item.amount,
      }))
    : [];
});
const chartDataSeriesByCategory = computed(() => {
  return props.chartData &&
    props.chartData.donationDistributionByOfferingCategory
    ? props.chartData.donationDistributionByOfferingCategory.map((item) => ({
        name: item.channel,
        y: item.amount,
      }))
    : [];
});
const trendAreaChartData = computed(() => {
  return props.chartData && props.chartData.monthlyGivingTrend
    ? props.chartData.monthlyGivingTrend.map((m) => m.amount)
    : [];
});

// Chart refs

const chartItemdropdown = ref([
  { name: "Month", id: 1 },
  { name: "Week", id: 2 },
]);
const setSelectedPeriod = (item) => {
  selectedPeriod.value = item;
  console.log(selectedPeriod.value, "jjuuus");
  emit("selected-period", selectedPeriod.value);
};

// Format number utility
const formatNumber = (number) => {
  return new Intl.NumberFormat("en-US").format(number);
};
const selectedType = (item) => {
  sortBy.value = item;
};

const handleChartClick = (data) => {
  console.log("Chart clicked:", data.point.name, data.point.y);
  // Handle chart segment click
};

const handleLegendClick = (data) => {
  console.log("Legend clicked:", data.point.name);
  // Handle legend item click
};

const onChartReady = (chart) => {
  console.log("Chart ready:", chart);
  // Handle chart ready event
};
// const getDonationSummary = async () => {
//   try {
//     const response = await contributionservice.getDonationSummary();
//     if (response) {
//       console.log(response, "donation summary");
//     }
//   } catch (error) {
//     console.log( error);
//   }
// };
// getDonationSummary()

// Drawing trend chart

// Drawing donut char
</script>

<style scoped>
.mt-1-5 {
  margin-top: 0.2rem !important;
}
.card-summary {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}
.donut_chart_container {
  height: 100%;
}
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.gap-3 > * + * {
  margin-left: 1rem;
}

.chart-container {
  background: #f8f9fa;
  border-radius: 0.375rem;
  padding: 1rem;
}

.card {
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
}

.btn-group-sm .btn {
  font-size: 0.875rem;
  padding: 0.25rem 0.75rem;
}

.position-relative canvas {
  max-width: 100%;
  height: auto;
}
.card-title {
  font-size: 25px !important;
  margin: 0;
  color: #000000;
}
.card-text {
  margin: 0;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #111111 !important;
}
</style>
